import { DetailsList, FontSizes, FontWeights, IconButton, PrimaryButton, SelectionMode, Stack } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { netGrossColumn, netGrossField } from "../../../Utilities/NetGrossField";
import EditAgreementProtocol from "../../../Panel/AgreementProtocol/EditAgreementProtocol";
import AuthContext from "../../../Services/AuthContext";
import { MoneyFormat } from "../../../Utilities/MoneyFormat";

function AgreementProtocolDataView({ agreement, items, netGross, refresh }) {
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [columns, setColumns] = useState([]);
    const [editProtocol, setEditProtocol] = useState(false);
    const _deleteCost = (item) => {
        fetch(`/api/agreement/protocol/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { refresh() })
            .catch(err => { console.log(err) })
    }
    useEffect(() => {
        setColumns([
        {
            key: 'number',
            name: 'Numer',
            ariaLabel: 'Numer',
            fieldName: 'number',
            minWidth: 210,
            maxWidth: 210,
            isRowHeader: true,
            isResizable: false,
            onRender: (item) => {
                const note = item.note !== null
                    ? <PrimaryButton text={item.number} title={item.note} iconProps={{iconName: 'Info'}} /> :
                    <PrimaryButton text={item.number} />;
                return (<Link to={`/venture/${params.id}/protocol/${item.id}`}>{note}</Link>)
            }
        },
        {
            key: 'date',
            name: 'Data',
            ariaLabel: 'Data',
            fieldName: 'date',
            isResizable: true,
            isSorted: true
        },
        {
            ...netGrossColumn()
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 70,
            maxWidth: 70,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditProtocol(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onDoubleClick={() => _deleteCost(item)}/>
            </span>)
        }
        ]);
    }, [netGross]);
    const sum = (subCosts) => {
        let total = 0;
        for (const item of subCosts) {
            total += parseFloat(item[netGrossField()]);
        }
        return MoneyFormat(total);
    };

    return <Stack.Item grow={true}>
        <h4 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>Protokoły</h4>
        <h4>{sum(items)} / {MoneyFormat(agreement[netGrossField()])}</h4>
        <DetailsList items={items} columns={columns} selectionMode={SelectionMode.none} />
        <EditAgreementProtocol add={editProtocol} onSuccess={refresh}
                               dismissPanel={() => setEditProtocol(false)} />
    </Stack.Item>;
}

export default AgreementProtocolDataView;